import { Controller } from "@hotwired/stimulus";

// "Marks are declared out of": thresholds are stored in percent, this only
// changes how they read on the page. The form still sends percents.
export default class extends Controller {
  static targets = ["base"];

  connect() {
    this.base = 100;
    this.form = this.element.closest("form");
    this.form?.addEventListener("submit", this.restore);
    this.baseTarget.value = this.remembered();
    this.change();
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.restore);
  }

  change() {
    const next = Number(this.baseTarget.value) || 100;
    this.fields.forEach((input) => {
      const percent = this.percentOf(input);
      if (percent === null) return;

      input.dataset.percent = percent;
      input.value = Math.round((percent * next) / 100 * 100) / 100;
      input.dataset.shown = input.value;
      input.max = next;
    });
    this.element.querySelectorAll("[data-scale-unit]").forEach((unit) => {
      unit.textContent = next === 100 ? "%" : `/${next}`;
    });
    this.base = next;
    this.remember(next);
  }

  restore = () => {
    this.fields.forEach((input) => {
      const percent = this.percentOf(input);
      if (percent !== null) {
        input.max = 100;
        input.value = percent;
      }
    });
  };

  // private

  get fields() {
    return this.element.querySelectorAll('input[name$="[from]"], input[name$="[below]"]');
  }

  // An untouched field keeps its exact percent: rounding must not drift it.
  percentOf(input) {
    if (input.value === "") return null;
    if (input.dataset.shown === input.value) return Number(input.dataset.percent);

    return (Number(input.value) * 100) / this.base;
  }

  remembered() {
    try {
      return localStorage.getItem("report-card-declared-scale") || "100";
    } catch {
      return "100";
    }
  }

  remember(value) {
    try {
      localStorage.setItem("report-card-declared-scale", value);
    } catch {
      // Private window: the choice lasts for the page.
    }
  }
}
